import type { BreadCrumbElement } from "app/components/BreadCrumbsHeader";

/**
 * Breadcrumbs for the consolidated Notifications views. The `tabs` crumb backs
 * both the breadcrumb header (which collapses it to the active tab) and the
 * vertical tab rail rendered by `NotificationsTabsLayout`, keeping the two in
 * sync.
 */
export function useNotificationsBreadcrumbs(): BreadCrumbElement[] {
  return [
    { label: "Notifications" },
    {
      tabs: [
        { label: "Overview", target: "/notifications/overview" },
        { label: "Settings", target: "/notifications/settings" },
        { label: "Rules", target: "/notifications/rules", chip: "preview" },
      ],
    },
  ];
}
